module.exports = __webpack_public_path__ + "static/media/pollari.25ca6a61.png";